// importeer hier alle scripts die je maakt

import Lenis from "lenis";
import "lenis/dist/lenis.css";

// Lenis smooth scrolling
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  touchMultiplier: 2,
});
window.lenis = lenis;

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

// Handle anchor links with smooth scroll
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    const target = document.querySelector(anchor.getAttribute("href"));
    if (target) {
      e.preventDefault();
      lenis.scrollTo(target);
    }
  });
});

import "./utils/favicon.js";
import "./utils/boxSizing.js";
import "./alpine/alpine.js";
import "./animations/animations.js";
import "./components/swiper.js";
import "./components/language-switcher.js";
import "./vendor/iubenda.js";
// import "./vendor/recaptcha.js";
import "./vendor/ga-slug.js";
import "./helpers/lazyImgs.js";
import "./components/count-up.js";

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {});
Fancybox.bind("[data-fancybox='gallery']", {});
